import React from "react";
import { Button, Form, Input, Table, Typography } from "antd";

import { formatNumber } from "../../helpers/formater";

const { Title, Text } = Typography;

const Provizija = ({ offer, actions }) => {
  const [form] = Form.useForm();

  const onFinish = ({ ponuda }) => {
    actions.getOfferByOfferNumber(ponuda);
  };

  return (
    <div className="p-8">
      <Title className="text-dark-blue text-xl font-bold mb-6">
        IZRAČUN PROVIZIJE
      </Title>
      <Form form={form} name="basic" onFinish={onFinish}>
        <div className="w-72">
          <Text className="text-xs font-light italic">
            Unesite broj ponude za izračun provizije:
          </Text>

          <Form.Item
            initialValue={offer && offer.offerNumber}
            className="mt-2 mb-6"
            name="ponuda"
            rules={[
              {
                required: true,
                message: "Unesite broj ponude!",
              },
            ]}
          >
            <Input type="number" placeholder="Broj ponude" />
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              className="text-sm text-white bg-green-izracun w-[108px] rounded-sm border-green-izracun shadow-sm"
            >
              IZRAČUNAJ
            </Button>
          </Form.Item>
        </div>
      </Form>

      {offer && (
        <div className="w-fit text-center mx-6 my-20">
          <div className="text-xl font-bold text-dark-blue">
            IZNOS BRUTO PROVIZIJE:
          </div>
          <div className="text-[32px] font-black text-dark-blue mt-2">
            {formatNumber(offer?.processingFee * 0.5)} {offer?.currency}
          </div>
        </div>
      )}
    </div>
  );
};

export default Provizija;
